import { Box, Button, Image } from '@rbilabs/universal-components';
import { Header as SectionHeader } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import Link from 'components/link';
import { primitive } from 'styles/constants';

export const ContentCardContainer = Box.withConfig({
  position: 'relative',
  shadow: 2,
  borderRadius: 16,
  marginY: 2,
  marginX: 1,
  background: 'white',
});

export const ContentCardGridItem = Box.withConfig({
  flex: 1,
});

export const ClassicCardContainer = Box.withConfig({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  height: '136px',
});

export const ClassicCardImage = Image.withConfig({
  height: 'auto',
  borderTopLeftRadius: 16,
  borderBottomLeftRadius: 16,
  _web: {
    height: 'full',
  },
});

export const ClassicCardContent = Box.withConfig({
  flex: 1,
  padding: {
    base: 4,
    sm: 5,
  },
});

export const CardTitle = SectionHeader.withConfig({
  variant: 'headerTwo',
  marginBottom: 2,
  numberOfLines: 2,
  ellipsizeMode: 'tail',
});

export const CardDescription = withTypography({
  variant: 'copyTwo',
  numberOfLines: 2,
  ellipsizeMode: 'tail',
});

export const ButtonContainer = Box.withConfig({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  marginTop: 4,
});

type CardButtonProps = {
  isChallenge?: boolean;
};

export const CardButton = Button.withConfig(({ isChallenge }: CardButtonProps) => ({
  variant: 'outline',
  ...(isChallenge && {
    variant: 'solid',
    backgroundColor: primitive.$meltyYellow,
    textDecorationColor: primitive.$meltyYellow,
    _hover: {
      backgroundColor: primitive.$meltyYellowDark45,
    },
    _pressed: {
      backgroundColor: primitive.$meltyYellowDark40,
    },
  }),
  size: 'md',
  _text: {
    ...(isChallenge && { color: primitive.$bbqBrown }),
  },
}));

export const CaptionedCardContainer = Box.withConfig({
  display: 'flex',
  flexDirection: 'column',
});

export const CaptionedCardImage = Image.withConfig({
  width: 'full',
  borderTopRadius: 16,
});

export const CaptionedCardContent = ClassicCardContent;

export const ImageOnlyCardImage = Image.withConfig({
  width: 'full',
  borderRadius: 16,
});

export const StyledLink = Link.withConfig({
  isUnderlined: true,
  isInline: true,
  variant: 'copyTwo',
  marginY: 2,
  _web: { cursor: 'pointer' },
});
